import { ELECTRIONIC_LOCKS } from '~/constants/domain'
import {
  useJourneyVehicleDetailsFragment,
  VehiclePropulsionType,
} from '~/gql/generated/graphql'

export const useJourneyVehicleData = (journeyId: string) => {
  const { data } = useJourneyVehicleDetailsFragment({
    id: journeyId,
  })

  const lockConfig = data.vehicle?.detail?.lock_configuration
  const hasELock = lockConfig && ELECTRIONIC_LOCKS.includes(lockConfig)

  const hasAssist = data.vehicle?.propulsion_type?.includes(
    VehiclePropulsionType.electric_assist,
  )

  return {
    hasELock,
    hasAssist,
  }
}
